import { sync } from 'vuex-router-sync'
import Vue from 'vue'
import ElementUI from 'element-ui'
import ElementUIDictionary from 'element-ui/lib/locale/lang/en'
import Root from './Root'
import Vuex from 'vuex';
import vuexI18n from 'vuex-i18n';
import translations from '../lang';

import validationDictinary from '../lang/validations';
import moment from 'moment'

import VeeValidate from 'vee-validate';
import { Validator } from 'vee-validate';

// Import and use Vue Froala lib.
import VueFroala from 'vue-froala-wysiwyg'


import vSelect from 'vue-select';

import ToggleButton from 'vue-js-toggle-button'

const Lang = 'en';

/**
* This is the Vuex store and it is
* avaible to all your components
*/
import store from './store'

/**
* This is the Router
*/
import router from './router'


/**
* $http plugin based on axios
*/
import httpPlugin from './plugins/http'

/**
* eventbus plugin
*/
import eventbus from './plugins/eventbus'


/**
* jQuery and Bootstrap includes
*/
require('./includes')

/**
* Vue Mixins
*/
require('./components/mixins/loader.js')
require('./components/mixins/validationErrors.js')

/**
* Make $http avaible to all components
* Send store and router to httpPlugin (injection)
*/
Vue.use(httpPlugin, { store, router })

import { apiUrl } from './config'
window.baseUrl = apiUrl;
/**
* Make $bus avaible to all components
*/
Vue.use(eventbus)

// Effortlessly keep vue-router and vuex store in sync.
sync(store, router) // https://github.com/vuejs/vuex-router-sync/tree/next


// initialize the vuex store using the vuex module. note that you can change the
//  name of the module if you wish
const hf = new Vuex.Store({
	modules: {
		i18n: vuexI18n.store
	}
});

Vue.use(ToggleButton);
Vue.use(VueFroala);

// Register a global custom directive called v-focus
Vue.directive('focus', {
  // When the bound element is inserted into the DOM...
  inserted: function (el) {
    // Focus the element
    el.focus()
  }
})

  var numeral = require("numeral");

  Vue.filter("formatNumber", function (value) {
    return numeral(value).format("0,0"); // displaying other groupings/separators is possible, look at the docs
  });
  
/**
* External Libraries used along with Vue
*/
Vue.use(vuexI18n.plugin, hf);
Vue.i18n.add('en', translations.en);
// Vue.i18n.add('de', translationsDe);
Vue.i18n.set(Lang);
moment().locale(Lang);

Vue.use(ElementUI, { locale:ElementUIDictionary });

Vue.use(VeeValidate,{ locale: Lang, events: 'blur' });

// infinite scroll
var infiniteScroll =  require('vue-infinite-scroll');
Vue.use(infiniteScroll)

Vue.config.lang = Lang;
// Validator.updateDictionary(validationDictinary);

Vue.component('v-select', vSelect);

var VueTruncate = require('vue-truncate-filter')
Vue.use(VueTruncate)

// Vue.component('campaignCard', require('./components/sub_component/campaignCard.vue'));
// Vue.component('bulkCampaignCard', require('./components/sub_component/bulkCampaignCard.vue'));
// Vue.component('educationCard', require('./components/sub_component/educationCard.vue'));
// Vue.component('scenarioCard', require('./components/sub_component/scenarioCard.vue'));
// Vue.component('editCampaignModal', require('./components/sub_component/editCampaignModal.vue'));
// Vue.component('campaignScheduleCard', require('./components/sub_component/campaignScheduleCard.vue'));
// Vue.component('nextButtonCard', require('./components/sub_component/nextButtonCard.vue'));

/* eslint-disable no-new */
new Vue({
    store, // injects the Store into all components
    router, // make Router work with the application
    el: '#app',
    render: h => h(Root),
});



// WEBPACK FOOTER //
// ./src/main.js